export const getCompanionLabel = (settings, isSingular) => {
  if (settings?.FO_MEETING_COMPANIONS_LABEL) {
    return isSingular ? settings?.FO_MEETING_COMPANIONS_LABEL : `${settings?.FO_MEETING_COMPANIONS_LABEL}(s)`
  }
  return isSingular ? 'accompagnant' : `accompagnant(s)`
}
